import React, { useState, Fragment, Component } from 'react'
import Shimmer from "react-shimmer-effect";
import {
    Container,
    Row, Col,
    CardBody, Card, CardTitle, CardSubtitle,
    Button,
    Table
} from "reactstrap"
import { Link, useHistory, useParams } from "react-router-dom"
import { withRouter } from "react-router";

import apiResponse from '../../../../services/apiResponse'

import DetailBloc from './Blocs/DetailBloc'
// import PegawaiSideBar from '../../GlobalComponents/PegawaiSidebar';

class IndexView extends Component {

    detailBloc = new DetailBloc()

    rupiah = (num) => {
        let res = "-";
        if (num != null && num != ''){
            res = parseFloat(num).toLocaleString('id-ID', {maximumFractionDigits:2})
        }
        return res;
    }

    constructor(props) {
        super(props)
        this.state = {}
    }

    componentDidMount() {
        this.detailBloc.detailChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.COMPLETED:
                    if(result.data.status) {
                        let response = result.data.response
                        console.log(response)
                        this.setState({
                            detail: response
                        })
                    }
                    break
                case apiResponse.ERROR:
                    
                    break
                default:
                    break
            }
        })
        const queryParams = new URLSearchParams(this.props.location.search)
        this.detailBloc.fetchDetail({uuid: queryParams.get('uuid') })
    }


    render() {
        return (
            <Fragment>
                <Container fluid>
                    <Row>
                        <Col className="col-12">

                            {/* <PegawaiSideBar active="skillcertification"/> */}

                            <Card>
                                <CardBody>
                                    <CardTitle>Detail Rekap Absensi</CardTitle>
                                    <CardSubtitle className="mb-3">
                                        Informasi Detail Rekap Absensi
                                    </CardSubtitle>
                                    <hr />
                                    <Row className="mb-3">
                                        <label className="col-md-3">
                                            NIP
                                        </label>
                                        <Col md="9">
                                            {
                                                this.state.detail ?
                                                    <>{this.state.detail.presensi_summary_employee_nip !== "" ? this.state.detail.presensi_summary_employee_nip : '-'}</>
                                                : <Shimmer><div style={{width: 68, height: 15}}></div></Shimmer>
                                            }
                                        </Col>
                                    </Row>
                                    <Row className="mb-3">
                                        <label className="col-md-3">
                                            Nama
                                        </label>
                                        <Col md="9">
                                            {
                                                this.state.detail ?
                                                    <>{this.state.detail.employee_full_name !== "" ? this.state.detail.employee_full_name : '-'}</>
                                                : <Shimmer><div style={{width: 68, height: 15}}></div></Shimmer>
                                            }
                                        </Col>
                                    </Row>
                                    <Row className="mb-3">
                                        <label className="col-md-3">
                                            Unit Kerja 
                                        </label>
                                        <Col md="9">
                                            {
                                                this.state.detail ?
                                                    <>{this.state.detail.employee_current_work_unit_name !== "" ? this.state.detail.employee_current_work_unit_name : '-'}</>
                                                : <Shimmer><div style={{width: 68, height: 15}}></div></Shimmer>
                                            }
                                        </Col>
                                    </Row>
                                    <Row className="mb-3">
                                        <label className="col-md-3">
                                            Jabatan 
                                        </label>
                                        <Col md="9">
                                            {
                                                this.state.detail ?
                                                    <>{this.state.detail.employee_current_position_name !== "" ? this.state.detail.employee_current_position_name : '-'}</>
                                                : <Shimmer><div style={{width: 68, height: 15}}></div></Shimmer>
                                            }
                                        </Col>
                                    </Row>

                                    <Row className="mb-3">
                                        <label className="col-md-3">
                                            Golongan Ruang 
                                        </label>
                                        <Col md="9">
                                            {
                                                this.state.detail ?
                                                    <>{this.state.detail.employee_current_rank_group_room !== "" ? this.state.detail.employee_current_rank_group_room : '-'}</>
                                                : <Shimmer><div style={{width: 68, height: 15}}></div></Shimmer>
                                            }
                                        </Col>
                                    </Row>

                                    <hr />
                                        <Row className="mb-3">
                                            <label className="col-md-3">
                                                Bulan
                                            </label>
                                            <Col md="9">
                                                {
                                                    this.state.detail ?
                                                        <>{this.state.detail.presensi_summary_month_name !== "" ? this.state.detail.presensi_summary_month_name : '-'}</>
                                                    : <Shimmer><div style={{width: 68, height: 15}}></div></Shimmer>
                                                }
                                            </Col>
                                        </Row>
                                        <Row className="mb-3">
                                            <label className="col-md-3">
                                                Tahun
                                            </label>
                                            <Col md="9">
                                                {
                                                    this.state.detail ?
                                                        <>{this.state.detail.presensi_summary_year !== "" ? this.state.detail.presensi_summary_year : '-'}</>
                                                    : <Shimmer><div style={{width: 68, height: 15}}></div></Shimmer>
                                                }
                                            </Col>
                                        </Row>
                                    <hr />

                                    <Table className="table-striped table-bordered">
                                        <thead>
                                            <tr>
                                                <th className="text-center" rowSpan="2">Jenis</th>
                                                <th className="text-center" rowSpan="2">Detail</th>
                                                <th className="text-center" colSpan="2">Persentase Potongan</th>
                                            </tr>
                                            <tr>
                                                <th className="text-center" >Tunkin</th>
                                                <th className="text-center" >Honorarium</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr>
                                                <td>Tidak Masuk</td>
                                                <td className="text-center">
                                                    {
                                                        this.state.detail ?
                                                            <>{(this.state.detail.presensi_summary_jumlah_tidak_masuk) !== "" ? (this.state.detail.presensi_summary_jumlah_tidak_masuk) : '-'}</>
                                                        : <Shimmer><div style={{width: 68, height: 15}}></div></Shimmer>
                                                    }
                                                </td>
                                                <td className="text-center">
                                                    {
                                                        this.state.detail ?
                                                            <>{(this.state.detail.presensi_summary_presentase_tunkin_tidak_masuk) !== "" ? (this.state.detail.presensi_summary_presentase_tunkin_tidak_masuk) + '%' : '-'}</>
                                                        : <Shimmer><div style={{width: 68, height: 15}}></div></Shimmer>
                                                    }
                                                </td>
                                                <td className="text-center">
                                                    {
                                                        this.state.detail ?
                                                            <>{(this.state.detail.presensi_summary_presentase_ptsp_tidak_masuk) !== "" ? (this.state.detail.presensi_summary_presentase_ptsp_tidak_masuk) + '%' : '-'}</>
                                                        : <Shimmer><div style={{width: 68, height: 15}}></div></Shimmer>
                                                    }
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>Telat Masuk</td>
                                                <td className="text-center">
                                                    {
                                                        this.state.detail ?
                                                            <>{(this.state.detail.presensi_summary_jumlah_telat_masuk) !== "" ? (this.state.detail.presensi_summary_jumlah_telat_masuk) : '-'}</>
                                                        : <Shimmer><div style={{width: 68, height: 15}}></div></Shimmer>
                                                    }
                                                </td>
                                                <td className="text-center">
                                                    {
                                                        this.state.detail ?
                                                            <>{(this.state.detail.presensi_summary_presentase_tunkin_telat_masuk) !== "" ? (this.state.detail.presensi_summary_presentase_tunkin_telat_masuk) + '%' : '-'}</>
                                                        : <Shimmer><div style={{width: 68, height: 15}}></div></Shimmer>
                                                    }
                                                </td>
                                                <td className="text-center">
                                                    {
                                                        this.state.detail ?
                                                            <>{(this.state.detail.presensi_summary_presentase_ptsp_telat_masuk) !== "" ? (this.state.detail.presensi_summary_presentase_ptsp_telat_masuk) + '%' : '-'}</>
                                                        : <Shimmer><div style={{width: 68, height: 15}}></div></Shimmer>
                                                    }
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>Pulang Cepat</td>
                                                <td className="text-center">
                                                    {
                                                        this.state.detail ?
                                                            <>{(this.state.detail.presensi_summary_jumlah_pulang_cepat) !== "" ? (this.state.detail.presensi_summary_jumlah_pulang_cepat) : '-'}</>
                                                        : <Shimmer><div style={{width: 68, height: 15}}></div></Shimmer>
                                                    }
                                                </td>
                                                <td className="text-center">
                                                    {
                                                        this.state.detail ?
                                                            <>{(this.state.detail.presensi_summary_presentase_tunkin_pulang_cepat) !== "" ? (this.state.detail.presensi_summary_presentase_tunkin_pulang_cepat) + '%' : '-'}</>
                                                        : <Shimmer><div style={{width: 68, height: 15}}></div></Shimmer>
                                                    }
                                                </td>
                                                <td className="text-center">
                                                    {
                                                        this.state.detail ?
                                                            <>{(this.state.detail.presensi_summary_presentase_ptsp_pulang_cepat) !== "" ? (this.state.detail.presensi_summary_presentase_ptsp_pulang_cepat) + '%' : '-'}</>
                                                        : <Shimmer><div style={{width: 68, height: 15}}></div></Shimmer>
                                                    }
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>Single Finger</td>
                                                <td className="text-center">
                                                    {
                                                        this.state.detail ?
                                                            <>{(this.state.detail.presensi_summary_jumlah_single_finger) !== "" ? (this.state.detail.presensi_summary_jumlah_single_finger) : '-'}</>
                                                        : <Shimmer><div style={{width: 68, height: 15}}></div></Shimmer>
                                                    }
                                                </td>
                                                <td className="text-center">
                                                    {
                                                        this.state.detail ?
                                                            <>{(this.state.detail.presensi_summary_presentase_tunkin_single_finger) !== "" ? (this.state.detail.presensi_summary_presentase_tunkin_single_finger) + '%' : '-'}</>
                                                        : <Shimmer><div style={{width: 68, height: 15}}></div></Shimmer>
                                                    }
                                                </td>
                                                <td className="text-center">
                                                    {
                                                        this.state.detail ?
                                                            <>{(this.state.detail.presensi_summary_presentase_ptsp_single_finger) !== "" ? (this.state.detail.presensi_summary_presentase_ptsp_single_finger) + '%' : '-'}</>
                                                        : <Shimmer><div style={{width: 68, height: 15}}></div></Shimmer>
                                                    }
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>Hukuman Disiplin</td>
                                                <td className="text-center">
                                                    -
                                                </td>
                                                <td className="text-center" colSpan="2">
                                                    {
                                                        this.state.detail ?
                                                            <>{(this.state.detail.presensi_summary_presentase_punishment_discipline) !== "" ? (this.state.detail.presensi_summary_presentase_punishment_discipline != null ? this.state.detail.presensi_summary_presentase_punishment_discipline : 0) + '%' : '-'}</>
                                                        : <Shimmer><div style={{width: 68, height: 15}}></div></Shimmer>
                                                    }
                                                </td>
                                            </tr>
                                        </tbody>
                                    </Table>
                                   
                                    <Row className="mb-3">
                                        <Col md="9">
                                            <Link to="/kepegawaian/verifikasi_kehadiran.html" className="waves-effect">
                                                <Button color="danger"><i className="uil-arrow-left"></i> Kembali</Button>
                                            </Link>
                                        </Col>
                                    </Row>
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                </Container>
            </Fragment>
        )
    }
}

//export default IndexView
export default withRouter(IndexView);